<section class="container-fluid faq" *ngIf="faq?.length">
  <div class="container">
    <div class="row">
      <div class="col-12 col-lg-3 col-xl-2">
        <h2>FAQ</h2>
      </div>
      <div class="col-12 col-lg-9 col-xl-10">
        <ngb-accordion id="acc" #acc="ngbAccordion"  [closeOthers]="true" >
          <ngb-panel id="headingOne">
            <ng-template ngbPanelTitle>
              <span>
                <span>За результатами тестування я маю високі показники. Чи означає це, що я маю розлад?</span>
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                Тестування не є діагностичною процедурою, однак виявляє можливість наявності розладу. Якщо Ви маєте високий бал за результатами певної методики, а проблеми, пов’язані із цим значною мірою турбують Вас, радимо звернутися до Вашого сімейного лікаря, психолога чи психіатра.</div>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="headingtwo">
            <ng-template ngbPanelTitle>
              <span >
                <span>Я отримую різні результати під час тестувань, тест не працює?</span>
                
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                <p>Тест виявляє Вашу актуальну тривожність, отож, зі зміною Вашого стану результати тесту будуть інакшими. Якщо після вправ чи занять з психологом Ваша тривожність зменшилась - це гарний знак!</p>
                <p>Це free view test, якщо Ви свідомо чи несвідомо намагались обрати стратегію перегляду, то це може вносити значні відхилення в кінцевий результат. Спробуйте пройти тест не зосереджуючись на власних реакціях та поведінці.</p>
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading2">
            <ng-template ngbPanelTitle>
              <span class="">
                <span>За результатами тестування я маю мінімальні показники, проте відчуваю себе тривожно.</span>
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                Можливо Вам тяжко перекласти тривогу у слова, через це стандартні методики виявляються неспроможними виявити тривогу, яку Ви маєте. Якщо показники АВВ також свідчать про мінімальний рівень тривоги, можливо Ваша тривога ситуативна (викликана лише зовнішніми факторами) і не пов'язана із зміною чутливості до загрозливих стимулів. Для Anima важливо також дотримання технічних умов тестування, які збільшують її чутливість. Спробуйте пройти тестування ще раз, дотримуючись рекомендацій до тестування.
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading3">
            <ng-template ngbPanelTitle>
              <span class="" >
                <span>Я приймаю ліки, чи впливають вони на результати тестування?</span>
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                Залежить від того, які ліки Ви приймаєте. Більшість психоактивних речовин впливають на наш психічний стан та реакцію, а отже будуть впливати на результат тестування. Антидепресанти та антиаксіолітики, наприклад, не впливають на нашу реакцію, проте покращують наше самопочуття, а відтак нашу думку про себе, що впливатиме на результати традиційних опитувальників. Якщо після прийому ліків у Вас покращився результат - це добрий знак!
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading4">
            <ng-template ngbPanelTitle>
              <span class="">
                <span>Чи може це тестування замінити похід до лікаря?</span>
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                Ні, АНІМА не є точною діагностичною методикою, оскільки процес діагностики без прямого контакту з фахівцем є неможливим. АНІМА допоможе Вам отримати показники, від яких Ви можете відштовхуватись у прийняті рішення, наприклад, щодо вибору копінг стратегій або походу до лікаря
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading5">
            <ng-template ngbPanelTitle>
              <span class="">
                <span>Результати попередніх тестувань були кращими, ніж нові. Це значить що мій стан погіршується?</span>
                
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                Не обов’язково. АНІМА виявляє актуальну тривожність, яка має тенденцію змінюватися. Можливо, щось тривожить Вас саме зараз? Якщо ж протягом багатьох послідовних тестувань Ви помічаєте погіршення Вашого стану та відчуваєте у себе значні симптоми тривоги, радимо звернутися до сімейного лікаря, психолога чи психіатра.
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading6">
            <ng-template ngbPanelTitle>
              <span class="">
                <span>Чому я маю високу тривогу, я психічно хворий?</span>
                
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                Тривога є нормальною реакцією на загрозу нашому життю. Саме тривога приводить в дію механізми, які допомагають нам виживати: битися, бігти та рятуватися. Однак, інколи ці механізми починають підсолювати один одного й ми відчуваємо тривогу тоді, коли навколо немає загрозливих речей. Якщо такий стан триває значний час (понад два тижні) та приносить значний дискомфорт в життя, радимо звернутися до сімейного лікаря, психолога чи психіатра. Ви не приречені, третина людей за все життя хоча б один раз відчуває надмірну тривогу без об’єктивної причини.
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading7">
            <ng-template ngbPanelTitle>
              <div class="">
                Чи можу я якимось чином покращити свої показники? Чи це мені потрібно?
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <span class="faq-item-text">
                Рівень тривоги є суб’єктивною величиною та залежить від багатьох показників, включаючи генетику та епігенетичні зміни. Тож, якщо Ви маєте тривогу вище середнього, однак це є Вашим нормальним станом, не обов’язково це змінювати. Якщо ж Ви відчуваєте дискомфорт від тривоги, Ви можете покращити Ваше самопочуття дослухаючись до рекомендацій, наданих після тестування.
              </span>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading81">
            <ng-template ngbPanelTitle>
              <span  id="heading8" class="" >
                <span>В мене не працює AAB тест, як це виправити?</span>
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                <p>Робота тесту залежить від декількох важливих параметрів:</p>
                <ol>
                  <li>
                    Для проходження тесту необхідно використовувати ноутбук, чи комп’ютер (планшет та телефон не підійде)
                  </li>
                  <li>
                    На Вашому пристрої має бути наявна веб-камера
                  </li>
                  <li>
                    Ви маєте дозволити сайту доступ до Вашої веб-камери&nbsp;
                  </li>
                  <li>
                    Використовуйте браузер Google Chrome
                  </li>
                  <li>
                    Якщо Ви маєте захворювання очей (травми очей, кератоконус, &nbsp;рathologic nystagmus та ін.), вони можуть значно вплинути на тестування
                  </li>
                  <li>
                    Можливо, помилка сталася під час процесу калібрування. Спробуйте пройти його ще раз. Для цього натисніть тут
                  </li>
                  <li>
                    Якщо сторінка підвисає чи прогружається занадто повільно, спробуйте перевірити якість інтернет з’єднання, або ж перезавантажити Ваш пристрій
                  </li>
                  <li>
                    Ваше лице має бути повністю охоплене камерою, на такій відстані, на якій ви бачите свої зіниці у камеру (30-60 см. від веб-камери). Камера має знаходитися нижче, чи на рівні очей
                  </li>
                  <li>
                    Ваше лице має бути якісно та рівномірно освітлюватися. Спробуйте змінити своє положення, якщо це не так
                  </li>
                  <li>
                    Якщо Ви проходите тест в окулярах подивіться, щоб бліки від освітлення не заслоняли Ваші очі. Інколи в лінзи окулярів вбудовані фільтри, що відбивають світло екрана або ламп, це заважає системі розпізнати рухи очей. Якщо це так, спробуйте під час налаштування системи змінити положення екрана ноутбука, або камери так щоб блік не перекривав зіниці. Або, якщо у Вас є така можливість, змініть окуляри на контактні лінзи.
                  </li>
                  <li>
                    У кадрі не має бути зайвих лиць чи зображень із лицями. Спробуйте змінити своє положення, якщо вони присутні у кадрі
                  </li>
                </ol>
              </div>
            </ng-template>
          </ngb-panel>
          <ngb-panel id="heading9">
            <ng-template ngbPanelTitle>
              <span class="" >
                <span>Що можна робити під час трекінгу, щоб збільшити достовірність результатів?</span>
              </span>
            </ng-template>
            <ng-template ngbPanelContent>
              <div class="faq-item-text">
                <ol>
                  <li>Переконайтесь, що Ваше робоче місце знаходиться в стабільному положенні та не тремтить під час проходження тестування. Якщо тремтіння помітні на камеру, спробуйте сидіти спокійно під час самого тестування.</li>
                  <li>По можливості не змінюйте положення Вашої голови та Вашої пози з моменту початку тестування.</li>
                  <li>Намагайтесь знайти місце зі стабільним освітленням, яке не буде змінюватися під час Вашого тестування та буде рівномірно освітлювати Ваше обличчя.</li>
                </ol>
              </div>
            </ng-template>
          </ngb-panel>
        </ngb-accordion>

<!--        <ngb-accordion id="acc" #acc="ngbAccordion" [closeOthers]="true" >-->
<!--          <ngb-panel id="headingOne">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>According to the test result, my anxiety level is high. Could this mean that I’m-->
<!--                  suffering from a disorder?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                The test is not a diagnostic procedure but can detect the probability of you developing-->
<!--                a disorder. If your test score is high and it is accompanied by problems that bother-->
<!--                you, we recommend that you see a doctor, psychologist, or psychiatrist.-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel id="headingtwo">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>I get different results with each test. Does the test not work?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <p>-->
<!--                  By taking the test, you will be able to determine the current level of anxiety that-->
<!--                  you are experiencing. This means that the results may change according to your-->
<!--                  current state of health.-->
<!--                <p> If you see a drop in anxiety after engaging in regular physical activity or-->
<!--                  communicating with a therapist, this is a great sign!</p>-->
<!--                <p>Anima is a free-view test. Therefore, it is possible to inadvertently or consciously-->
<!--                  change the results if you adopt a new observation strategy. Try to pass the test-->
<!--                  without giving much thought to your behavior or reactions.-->
<!--                </p>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel id="heading2">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>According to the test results, I have the lowest anxiety index but feel anxious. How-->
<!--                  is this possible?</span>-->


<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <p>If you struggle to find the words that adequately explain your anxiety, your-->
<!--                  condition may be difficult to diagnose using more conventional methods.</p>-->
<!--                <p>Your low score on the AAB test suggests that your anxiety is situational rather than-->
<!--                  based on your sensitivity to threatening stimuli.</p>-->
<!--                <p>The “technical sensitivity” of the Anima test requires that you strictly adhere to-->
<!--                  the technical rules of the test. Otherwise, it is possible to get inaccurate-->
<!--                  results.</p>-->
<!--                <p>If you believe that you did not take the test correctly, try retaking the test and be-->
<!--                  sure to carefully apply the on-screen suggestions.-->
<!--                </p>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel id="heading3">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>I am on medication. Can this affect the test results?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <p>Everything relies on what you consume. The majority of psychoactive substances have-->
<!--                  an impact on our mental state and response, which will affect the test findings.</p>-->
<!--                <p>Conversely, antidepressants and anxiolytics strengthen our overall health and-->
<!--                  self-esteem rather than jeopardize our reactions, which will also have an impact on-->
<!--                  the outcomes of conventional surveys.</p>-->
<!--                <p>If your outcomes have improved after taking medication, that’s a fantastic sign!</p>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel id="heading4">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>Can this test substitute for a visit to a doctor?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <p>Anima is unable to provide a comprehensive diagnosis. It is not possible to get-->
<!--                  properly diagnosed without first speaking in person with a physician.</p>-->
<!--                <p>Anima is able to give you the trustworthy information you need in order to make an-->
<!--                  educated decision about which coping strategies to use or whether you should go see-->
<!--                  a doctor.</p>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel id="heading5">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>Previous test results were better than the new ones. Does this mean that my-->
<!--                  condition is getting worse?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <p>In most cases, no. The anxiety levels that Anima measures are dynamic and may change-->
<!--                  at any time. A worse result could just mean something is bothering you at the time-->
<!--                  of the test.</p>-->
<!--                <p>But let’s say you’ve had a slew of tests that all point to a steady decline in your-->
<!--                  health while your anxiety symptoms have been increasing in intensity. In this case,-->
<!--                  we advise that you seek the help of a medical professional, a psychologist, or a-->
<!--                  psychiatrist.</p>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel id="heading6">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>Why is my anxiety high? Am I mentally ill?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <p>The human response to danger is anxiety. Anxiety, in particular, triggers the-->
<!--                  survival instincts that allow us to fight, flee, and save ourselves.</p>-->
<!--                <p>Yet these defenses can reinforce one another, leading to feelings of anxiety even-->
<!--                  when there is no actual danger present. A visit to a physician, psychologist, or-->
<!--                  psychiatrist is advised if you experience severe distress from such a situation for-->
<!--                  longer than two weeks.</p>-->
<!--                <p>If you have high anxiety, don’t worry; you are not doomed! 50% of US adults will-->
<!--                  experience mental health issues at some point n their adult lives, and about 20% of-->
<!--                  US adults experience mental health problems in any given year. You are definitely-->
<!--                  not alone if you need to seek treatment.</p>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel >-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span  id="heading7">Is there a way I can improve my results? And do I need my results to be-->
<!--                  “better”?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <p>The number of elements that contribute to one’s level of anxiety is directly-->
<!--                  proportional to their level of anxiety.</p>-->
<!--                <p>If having a higher-than-average anxiety index feels like your normal condition, then-->
<!--                  it is not necessary for you to make any changes.</p>-->
<!--                <p>In the event that anxiety is making your life more challenging, the findings of the-->
<!--                  test will give recommendations on how to reduce the severity of your symptoms.</p>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel id="heading8">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>The AAB test does not work. How do you fix this?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <p>The test depends on several important parameters:</p>-->
<!--                <ol>-->
<!--                  <li>The test can only be taken on a laptop or PC; it is not designed for use on a-->
<!--                    tablet or smartphone.-->
<!--                  </li>-->
<!--                  <li>In order to use an external camera, your device must already have one built-->
<!--                    in.-->
<!--                  </li>-->
<!--                  <li>The website will need access to your camera.</li>-->
<!--                  <li>The Google Chrome web browser is recommended.</li>-->
<!--                  <li>If you have an eye condition (eye trauma, keratoconus, pathological nystagmus,-->
<!--                    etc.), it can impact the test significantly.-->
<!--                  </li>-->
<!--                  <li>There could have been an error during the calibration process. Try the test-->
<!--                    again.-->
<!--                  </li>-->
<!--                  <li>If the page lags or loads too slowly, try checking the quality of the Internet-->
<!--                    connection, or restart your device.-->
<!--                  </li>-->
<!--                  <li>The camera must be positioned 12 to 24 inches from your pupils (you should be-->
<!--                    able to see them on the screen), and it must be able to capture your face fully.-->
<!--                    Place the camera at or below eye level.-->
<!--                  </li>-->
<!--                  <li>Your face must be properly lighted. Change your position if it’s not.</li>-->
<!--                  <li>If you are wearing glasses, make sure there is no glare from lighting-->
<!--                    obstructing the camera’s view of your eyes. Sometimes, lenses have in-built-->
<!--                    filters that reflect light from a screen or lamp, which might prevent the system-->
<!--                    from recognizing your eye movements. If this is the case, try changing the-->
<!--                    screen or camera position to avoid glare reflecting on your pupils.-->
<!--                  </li>-->
<!--                  <li>There must be no other faces or face images in the frame.</li>-->
<!--                </ol>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--          <ngb-panel id="heading9">-->
<!--            <ng-template ngbPanelTitle>-->
<!--              <span>-->
<!--                <span>Is there something I can do during the eye-tracking procedure to ensure a credible-->
<!--                  result?</span>-->

<!--              </span>-->
<!--            </ng-template>-->
<!--            <ng-template ngbPanelContent>-->
<!--              <span class="faq-item-text">-->
<!--                <ol>-->
<!--                  <li>Make sure you are positioned firmly during the test (your chair or the surface-->
<!--                    your gadget is placed on should remain still). If there is visible vibration or-->
<!--                    movement on camera, try changing your location.-->
<!--                  </li>-->
<!--                  <li>Once the test starts, try not to change your head and body position.</li>-->
<!--                  <li>Look for a place with stable lighting that covers your face evenly and won’t-->
<!--                    change during the test.-->
<!--                  </li>-->
<!--                </ol>-->
<!--              </span>-->
<!--            </ng-template>-->
<!--          </ngb-panel>-->
<!--        </ngb-accordion>-->

      </div>
    </div>
  </div>
</section>

